import { Suggestion } from 'types/suggestions';

export const getCategoryUrl = (suggestion: Suggestion | null) => {
  if (!suggestion) return null;
  if ('categoryUrl' in suggestion && suggestion.categoryUrl) return suggestion.categoryUrl;
  if ('pageUrl' in suggestion && suggestion.pageUrl) return suggestion.pageUrl;
  return null;
};
